<template>
  <v-window-item class="context-menu-window-item" :key="props.index" :value="props.index" transition="v-fade-transition"
    reverse-transition="v-fade-transition">
    <v-card class="d-flex flex-column conditions-card">
      <v-card-title :style="{ 'padding-left': props.index !== 0 ? '0 !important' : undefined }"
        class="select-popup-header d-flex justify-space-between align-center">
        <div class="d-flex align-center ga-3">
          <v-btn class="px-6 py-5 d-flex" v-if="props.index !== 0" style="padding: 0 !important;" icon density="compact" size="default"
            variant="text" @click="returnWindow">
            <v-icon size="default">mdi-arrow-left</v-icon>
          </v-btn>
          <p>{{ props.titulo }}</p>
        </div>
        <v-btn icon density="compact" size="default" variant="text" @click="closeMenu">
          <v-icon size="default">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div class="flex-grow-1 d-flex flex-column overflow-hidden">
        <div v-if="props.condition" class="flex-shrink-0">
          <v-select v-model="currentFilter" flat hide-details width="170px" height="40px" color="primary-60"
            density="compact" variant="solo" class="condition-select" :items="filterOptions"></v-select>
          <v-divider class="w-100"></v-divider>
        </div>
        <div v-if="showSearch" class="search-container pa-2 flex-shrink-0">
          <rb-input v-model="searchQuery" prepend-inner-icon="mdi-magnify" placeholder="Pesquisar"
            hide-details></rb-input>
        </div>
        <div v-if="showAllCheckbox" class="sticky-header flex-shrink-0">
          <div class="d-flex align-center">
            <v-checkbox v-model="isAllSelected" class="px-4" hide-details label="Todos"
              @click="toggleAllCheckboxes"></v-checkbox>
            <v-tooltip location="end">
              <template v-slot:activator="{ props: tooltipProps }">
                <v-icon v-bind="tooltipProps" color="neutral-35" icon="mdi-information" size="small"></v-icon>
              </template>
              <span>Ao selecionar todos, novos itens <br> serão automaticamente incluídos.</span>
            </v-tooltip>
          </div>
          <v-divider></v-divider>
        </div>
        <div class="content-container position-relative">
          <v-list class="list-container">
            <v-list-item v-if="isEmptyStateFilter" class="text-center empty-filter-text">
              <v-list-item-title>
                <span v-if="currentFilter === 'Vazio'">Serão filtrados todos com campo <b>vazio</b>.</span>
                <span v-if="currentFilter === 'Não está vazio'">Serão filtrados todos que o campo <b>não está
                    vazio</b>.</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-else-if="filteredData.length === 0" class="text-center">
              <v-list-item-title>{{ props.notFound }}</v-list-item-title>
            </v-list-item>
            <template v-else>
              <div v-if="props.type === 'list-item'" class="virtual-scroll-container">
                <v-virtual-scroll :items="filteredData" :key="`virtual-scroll-${currentFilter}`">
                  <template v-slot:default="{ item }">
                    <v-list-item class="py-4" append-icon="mdi-menu-right" @click="selectItem(item)">
                      {{ getItemTitle(item) }}
                    </v-list-item>
                  </template>
                </v-virtual-scroll>
              </div>
              <template v-else-if="showCheckboxes">
                <v-virtual-scroll :items="filteredData" height="225" :key="`virtual-scroll-${currentFilter}`"
                  @scroll="emitScroll">
                  <template v-slot:default="{ item }">
                    <v-checkbox :model-value="isItemSelected(item)" class="px-4" hide-details
                      :label="getItemTitle(item, true)" @click="toggleCheckbox(item)">
                    </v-checkbox>
                  </template>
                </v-virtual-scroll>
              </template>
            </template>
          </v-list>
        </div>
      </div>
      <div v-if="props.type === 'checkbox'" class="footer-container">
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end pa-2">
          <v-btn class="px-6 py-5 d-flex" color="primary-60" rounded="xl" variant="elevated" @click="saveFilters">
            Salvar
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-window-item>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch, onMounted } from 'vue';

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  search: { type: Boolean, default: true },
  condition: { type: Boolean, default: false },
  type: { type: String, default: 'list-item' },
  titulo: { type: String, default: 'Escolha um item' },
  data: { type: Array, default: () => [] },
  searchType: { type: String, default: 'simple' },
  index: { type: Number, required: true },
  reset: { type: Boolean, default: false },
  notFound: { type: String, default: 'Nenhum item encontrado' },
  conditionValue: {type: String, default: ""},
  stateControl: { type: Boolean, default: false }
});
const searchTimeout = ref(null);

const emit = defineEmits([
  'menuSelect', 'menuReturn', 'update:reset', 'menuClose',
  'update:stateControl', 'menuSave', 'scrolledItens', 'search'
]);

const searchQuery = ref('');
const currentFilter = ref('Contém');
const filterOptions = ['Contém', 'Não contém', 'Não está vazio', 'Vazio'];
const selectedItems = ref(new Map());

const createDefaultFilterModel = () => ({
  'Contém': { dados: [], todos: false, codigo: 'CONTEM', _selectedIds: [] },
  'Não contém': { dados: [], todos: false, codigo: 'NAO_CONTEM', _selectedIds: [] },
  'Não está vazio': { state: false, todos: false, codigo: 'NAO_VAZIO' },
  'Vazio': { state: false, todos: false, codigo: 'VAZIO' }
});

const filterModel = ref(createDefaultFilterModel());

const emitScroll = (event) => emit('scrolledItens', event);
const showSearch = computed(() => props.search && !isEmptyStateFilter.value);
const showAllCheckbox = computed(() => props.type === 'checkbox' && !isEmptyStateFilter.value);
const showCheckboxes = computed(() => props.type === 'checkbox' && !isEmptyStateFilter.value);
const isEmptyStateFilter = computed(() => ['Vazio', 'Não está vazio'].includes(currentFilter.value));

const isAllSelected = computed(() => {
  const currentCondition = filterModel.value[currentFilter.value];
  if (currentCondition.todos) return true;

  const dataToCheck = searchQuery.value ? filteredData.value : props.data;
  return dataToCheck.length > 0 && dataToCheck.every(item => isItemSelected(item));
});

const filteredData = computed(() => {
  if (!searchQuery.value) return props.data || [];

  if (props.searchType === 'simple') {
    const query = searchQuery.value.toLowerCase();
    return (props.data || []).filter(item => {
      if (!item) return false;
      const title = (item.titulo || '').toLowerCase();
      const name = (item.nome || '').toLowerCase();
      return title.includes(query) || name.includes(query);
    });
  }

  return props.data || [];
});

const searchItems = () => {
  if (searchTimeout.value) clearTimeout(searchTimeout.value);

  searchTimeout.value = setTimeout(() => {
    if (props.searchType === 'complex') {
      emit('search', searchQuery.value);
    }
  }, 300);
};

watch(() => searchQuery.value, () => {
  searchItems();
});

const getItemTitle = (item, codigo = false) => {
  const name = item?.titulo || item?.nome || ''
  if (codigo && item.codigo) return `${item.codigo} - ${name}`
  return name;
};

const isItemSelected = (item) => item?.id && (filterModel.value[currentFilter.value].todos || selectedItems.value.has(item.id));
const selectItem = (item) => emit('menuSelect', item);
const returnWindow = () => emit('menuReturn');
const closeMenu = () => emit('menuClose');

const toggleCheckbox = (item) => {
  if (!item?.id) return;
  const currentCondition = filterModel.value[currentFilter.value];
  if (currentCondition.todos) {
    currentCondition.todos = false;
    selectedItems.value.clear();

    props.data.forEach(dataItem => {
      if (dataItem?.id && dataItem.id !== item.id) selectedItems.value.set(dataItem.id, dataItem);
    });
    currentCondition._selectedIds = Array.from(selectedItems.value.keys());
    return;
  }

  if (selectedItems.value.has(item.id)) {
    selectedItems.value.delete(item.id);
    currentCondition._selectedIds = Array.from(selectedItems.value.keys());
    return;
  }
  selectedItems.value.set(item.id, item);
  currentCondition._selectedIds = Array.from(selectedItems.value.keys());
};

const toggleAllCheckboxes = () => {
  const currentCondition = filterModel.value[currentFilter.value];

  if (currentCondition.todos || isAllSelected.value) {
    currentCondition.todos = false;
    selectedItems.value.clear();
    currentCondition._selectedIds = [];
    return;
  }

  if (searchQuery.value) {
    filteredData.value.forEach(item => {
      if (item?.id) selectedItems.value.set(item.id, item);
    });
    currentCondition._selectedIds = Array.from(selectedItems.value.keys());
    return;
  }

  currentCondition.todos = true;
  selectedItems.value.clear();
  currentCondition._selectedIds = [];
};

const saveFilters = () => {
  const result = createDefaultFilterModel();
  const currentCondition = filterModel.value[currentFilter.value];
  result[currentFilter.value] = JSON.parse(JSON.stringify(currentCondition));

  if (currentFilter.value === 'Vazio' || currentFilter.value === 'Não está vazio') {
    result[currentFilter.value].state = true;
    emit('menuSave', result);
    return;
  }

  result[currentFilter.value].todos = currentCondition.todos;
  if (!currentCondition.todos) {
    result[currentFilter.value].dados = Array.from(selectedItems.value.values());
    result[currentFilter.value]._selectedIds = Array.from(selectedItems.value.keys());
  }
  emit('menuSave', result);
};

const loadSelections = () => {
  selectedItems.value.clear();
  if (!props.modelValue) return;

  Object.entries(props.modelValue).forEach(([condition, value]) => {
    if (!value) return;

    filterModel.value[condition] = {
      ...value,
      _selectedIds: value._selectedIds || []
    };

    if (condition !== currentFilter.value || value.todos) return;

    if (value._selectedIds?.length > 0) {
      const ids = new Set(value._selectedIds);
      props.data.forEach(item => {
        if (item?.id && ids.has(item.id)) selectedItems.value.set(item.id, item);
      });
      return;
    }

    if (value.dados?.length > 0) {
      value.dados.forEach(item => {
        if (item?.id) selectedItems.value.set(item.id, item);
      });
    }
  });
};

const resetComponent = () => {
  searchQuery.value = '';
  currentFilter.value = 'Contém';
  selectedItems.value.clear();
  filterModel.value = createDefaultFilterModel();
  emit('update:reset', false);
};

watch(() => props.data, () => {
  const currentCondition = filterModel.value[currentFilter.value];
  if (!currentCondition || currentCondition.todos) return;

  if (currentCondition._selectedIds?.length > 0) {
    const ids = new Set(currentCondition._selectedIds);
    props.data.forEach(item => {
      if (item?.id && ids.has(item.id)) selectedItems.value.set(item.id, item);
    });
  }
}, { deep: true });

watch(() => props.reset, (newVal) => newVal && resetComponent());
watch(() => props.stateControl, (newVal) => {
  if (!newVal) return;
  loadSelections();
  emit('update:stateControl', false);
});

watch(() => currentFilter.value, () => {
  selectedItems.value.clear();
  loadSelections();
});

watch(() => props.conditionValue, (newVal) => {
  if (newVal && filterOptions.includes(newVal)) {
    currentFilter.value = newVal;
    emit('update:stateControl', false);
  }
});

onMounted(loadSelections);
</script>

<style scoped>
.conditions-card {
  max-height: 500px;
}

.empty-filter-text {
  color: #7d8080;
}

.select-popup-header {
  padding-right: 8px !important;
  color: rgb(var(--v-theme-neutral-35));
  background-color: rgb(var(--v-theme-neutral-95));
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}

.content-container {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.list-container {
  flex: 1;
  overflow: hidden;
}

.virtual-scroll-container {
  width: 100%;
  height: 100%;
}

.footer-container {
  background-color: white;
}
</style>
